// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__21Xlw","signatureButtonsRight":"ModalSign_signatureButtonsRight__2RSD9"};